import { localStorageKeys } from '@/registry/local-storage-keys'

interface SizeSelectionHistory {
  [brandEnglishName: string]: string
}

export default class SizeSelectionHistoryRepository {
  private static readonly key = localStorageKeys.apparelAddToCartRecentSizePathnamesByBrand

  public constructor(private readonly brandEnglishName: string) {}

  public load(): string | null {
    try {
      const value = localStorage.getItem(SizeSelectionHistoryRepository.key)
      if (value === null) {
        return null
      }

      const parsed: unknown = JSON.parse(value)
      if (!this.isSizeSelectionHistory(parsed)) {
        throw new Error('size selection history in localStorage should be object')
      }

      const pathname = parsed[this.brandEnglishName]

      return pathname || null
    } catch {
      this.removeInvalidValue()

      return null
    }
  }

  public save(sizePathname: string): void {
    try {
      const current = this.loadAll()
      const next: SizeSelectionHistory = {
        ...current,
        [this.brandEnglishName]: sizePathname,
      }

      localStorage.setItem(
        SizeSelectionHistoryRepository.key,
        JSON.stringify(next)
      )
    } catch {
      // localStorage が利用不可の場合は無視
    }
  }

  private loadAll(): SizeSelectionHistory {
    try {
      const value = localStorage.getItem(SizeSelectionHistoryRepository.key)
      if (value === null) {
        return {}
      }

      const parsed: unknown = JSON.parse(value)
      if (!this.isSizeSelectionHistory(parsed)) {
        throw new Error('size selection history in localStorage should be object')
      }

      return parsed
    } catch {
      this.removeInvalidValue()

      return {}
    }
  }

  private isSizeSelectionHistory(value: unknown): value is SizeSelectionHistory {
    return typeof value === 'object' &&
      value !== null &&
      !Array.isArray(value) &&
      Object.keys(value).every(key => typeof (value as { [key: string]: unknown })[key] === 'string')
  }

  private removeInvalidValue(): void {
    try {
      localStorage.removeItem(SizeSelectionHistoryRepository.key)
    } catch {
      // localStorage が利用不可の場合は無視
    }
  }
}
